export const firebaseConfig = {
  apiKey: "AIzaSyAsbtpCdGh221vg3FBVvQ8aztlimM5T-kQ",
  authDomain: "mndcntrledx.firebaseapp.com",
  projectId: "mndcntrledx",
  storageBucket: "mndcntrledx.appspot.com",
  messagingSenderId: "351097990807",
  appId: "1:351097990807:web:01ec706780c9aee636c3d2",
  measurementId: "G-X6W8WMV41D",
};
